import { HUNGER_DECAY_MS, FEED_AMOUNT } from './constants';

const clamp = (n: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, n));

export function tickHunger(value: number, dtMs: number, decayMul = 1, decayMs = HUNGER_DECAY_MS): number {
  if (dtMs <= 0) return clamp(value, 0, 100);
  const drop = (dtMs / decayMs) * decayMul;
  return clamp(value - drop, 0, 100);
}

export function feed(value: number): number {
  return clamp(value + FEED_AMOUNT, 0, 100);
}

export function canFeed(value: number, lastFeedAt: number, nowMs: number): boolean {
  void lastFeedAt;
  void nowMs;
  if (value >= 100) return false;
  return true;
}
